import { requests } from "utils";
import { URL } from "./constants";

export function createSsoLoginRequest(payload: any) {
  return requests.post(URL, JSON.stringify(payload));
}
